<div class="print-wrapper">
  <app-commercial-invoice
    *ngIf="printData?.isFrom === 'air-waybill-commercial-invoice'"
    [airwayBillInvoiceData]="printData">
  </app-commercial-invoice>

  <app-air-waybill-generation-preview
    *ngIf="printData?.isFrom === 'air-waybill-gen-preview'"
    [airwayBillData]="printData"></app-air-waybill-generation-preview>
</div>
